<div class="card">
    <div class="card-header">
        <h1>Balance
        </h1>
    </div>
    <div class="row">
        <div class="col-sm-3 form-group" *ngIf="showPartnerFilter">
            <label for="partner" class="form-label">Partner</label>
            <div class="input-group">
                <app-input-autocomplete id="input-partner" (changeStatus)="selectPartner($event.filterElement)"
                    (inputMethod)="searchPartner()" [allBorderRadius]="true" [filterElements]="partners"
                    [placeholder]="'Busca un partner'" [custom]="true" [inputs]="inputPartner">
                    <ng-template #itemsTemplate let-filter>
                        <div items>
                            <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
                                {{filter.name}}</h5>
                            <span class="text-muted" style="color: white !important;">
                                {{filter.email}}
                            </span>
                        </div>
                    </ng-template>
                </app-input-autocomplete>
            </div>
        </div>
        <div class="col-sm-6 form-group">
            <label for="company" class="form-label">Empresa:</label>
            <div class="input-group">
                <app-input-autocomplete id="input-company" (changeStatus)="selectCompany($event.filterElement)"
                    (inputMethod)="searchCompany()" [allBorderRadius]="true" [filterElements]="companies"
                    [placeholder]="'Busca una empresa'" [custom]="true" [inputs]="inputCompany">
                    <ng-template #itemsTemplate let-filter>
                        <!-- This is the content that will be projected -->
                        <div items>
                            <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
                                {{filter.companyName?filter.companyName:filter.name}}</h5>
                            <span class="text-muted" style="color: white !important;">{{filter.alphanumericId}} -
                                NIT: <b>{{filter.companyNIT?filter.companyNIT:filter.nit}}</b></span>
                        </div>
                    </ng-template>
                </app-input-autocomplete>
            </div>
        </div>
        <div class="col-sm-3 form-group">
            <label for="endDate" class="form-label">Fecha Final</label>
            <input type="date" name="endDate" id="endDate" [(ngModel)]="endDate" class="form-control">
        </div>
        <app-loading-button style="width: 100%;" [logo]="true" [colorLoading]="'white'" [object]="buttonSave"
            (clicked)="filter()"></app-loading-button>
    </div>
    <div class="card-body">
        <div class="table-responsive mt-1" style="margin: 0; max-height: 70vh;">
            <table class="table table-striped" style="margin: 0;">
                <thead class="sticky-thead">
                    <tr class="tr-middle">
                        <!--<th>Codigo</th> -->
                        <th class="sticky-col first-col">
                            Partner
                        </th>
                        <th *ngFor="let col of columns">
                            <i *ngIf="col.minimized" title="Expandir {{col.name}}" (click)="minimize(col, false)"
                                class="fa fa-maximize clickeable"></i>
                            <ng-container *ngIf="!col.minimized">
                                {{col.name}}
                                <br>
                                <i class="fa" (click)="sort(col.displayId)"
                                    [ngClass]="
                                        {'fa-arrow-right-arrow-left': sortColumn === '' || sortColumn !== col.displayId, 
                                        'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === col.displayId, 
                                        'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === col.displayId}"></i>
                                <i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize(col)"></i>
                            </ng-container>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="!buttonSave.loading || pagination.filter.length > 0">
                        <tr *ngFor="let companyId of pagination.filter" class="tr-middle">
                            <td class="sticky-col first-col" style="min-width: 200px;">
                                <p class="titles">{{ companyInfos[companyId]?.nitCompany }}</p>
                                <p class="fields">NIT</p>
                                <p class="titles" [tooltip]="companyInfos[companyId]?.nameCompany">{{
                                    cropName(companyInfos[companyId]?.nameCompany) }}</p>
                                <p class="fields">Nombre</p>
                            </td>
                            <td *ngFor="let col of columns; let i = index">
                                <ng-container *ngIf="!col.minimized">
                                    <ng-container *ngIf="i !== 8 && i !== 15 && i < 21">
                                        {{ getBalanceById(companyId, col.displayId) | number:'1.2-2' }}
                                    </ng-container>
                                    <ng-container *ngIf="i === 8">
                                        {{ balances[companyId]?.totalDebe | number:'1.2-2' }}
                                    </ng-container>
                                    <ng-container *ngIf="i === 15">
                                        {{ balances[companyId]?.totalHaber - getCapitalBalance(companyId) |
                                        number:'1.2-2'
                                        }}
                                    </ng-container>
                                    <ng-container *ngIf="i === 21">
                                        {{ balances[companyId]?.utilidad | number:'1.2-2' }}
                                    </ng-container>
                                    <ng-container *ngIf="i === 22">
                                        {{ getCapitalBalance(companyId) | number:'1.2-2' }}
                                    </ng-container>
                                    <ng-container *ngIf="i === 23">
                                        {{ balances[companyId]?.totalDebe - balances[companyId]?.totalHaber -
                                        balances[companyId]?.utilidad | number:'1.2-2' }}
                                    </ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="pagination.filter.length == 0">
                        <td colspan="25">
                            <span class="display-5" style="opacity: 0.6; display: flex;">
                                <ng-container *ngIf="buttonSave.loading">
                                    <app-loading-animation [height]="'3rem'"
                                        *ngIf="buttonSave.loading"></app-loading-animation>
                                    Cargando...
                                </ng-container>
                                <ng-container *ngIf="!buttonSave.loading">
                                    <i class="fa fa-circle-info"></i>
                                    {{sought?'No se encontraron resultados':'Presiona el botón de buscar'}}
                                </ng-container>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-pagination-custom [elements]="pagination"></app-pagination-custom>
    </div>
</div>